export default "__VITE_ASSET__BBrgL1do__"